<template class="coba">
    <v-container fill-height>
        <v-layout row wrap align-center justify-center>
            <v-flex xs12 sm6>
                <v-flex xs12>
                    <div class="text-xs-center ma-3">
                        <img src="/images/logo.png">
                    </div>
                </v-flex>
                <v-flex xs12>
                    <v-card>
                    <v-card-title primary-title>
                        <h3 class="headline mx-auto">{{ title + " " + appName }}</h3>
                    </v-card-title>
                    <v-card-actions>
                        <v-layout row>
                            <v-flex xs12>
                                <form @submit.prevent="login">
                                    <v-text-field
                                            label="Username (Nomor Handphone)"
                                            name="form.email"
                                            v-model="form.email"
                                            :error-messages="email_errors"
                                            @blur="$v.form.email.$touch()"
                                            @input="$v.form.email.$touch()"
                                            hint="Gunakan nomor HP anda sebagai username, jika telah mendaftar."
                                            persistent-hint
                                            required
                                    ></v-text-field>
                                    <v-text-field
                                            label="Password"
                                            name="form.password"
                                            v-model="form.password"
                                            :error-messages="password_errors"
                                            @blur="$v.form.password.$touch()"
                                            @input="$v.form.password.$touch()"
                                            :counter="20"
                                            min="6"
                                            :append-icon="password_visibility ? 'visibility' : 'visibility_off'"
                                            @click:append="() => (password_visibility = !password_visibility)"
                                            :type="password_visibility ? 'text' : 'password'"
                                            required
                                    ></v-text-field>
                                    <v-layout row wrap align-center justify-center>
                                        <v-flex xs12 sm12 md5 ma-2>
                                            <v-btn name="login" type="submit" block color="primary" class="ma-0">Login
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs12 sm12 md5 ma-2>
                                            <v-btn to="/register" name="daftar" block color="accent" class="ma-0">Buat
                                                akun?
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row align-center justify-center>
                                        <v-flex xs12 sm12 md5>
                                            <v-btn to="/lupa_password" block flat color="primary" class="ma-0">Lupa password?</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </form>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-card>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {validationMixin} from 'vuelidate';
    import {required} from 'vuelidate/lib/validators';
    import store from '@/store/index';
    import BasicNavigation from "@/components/BasicNavigation";

    const {appName, appSubName, logo} = store.getters['config/data'];

    export default {
        layout: 'basic',
        components: {
            BasicNavigation
        },

        metaInfo() {
            return {title: this.title}
        },

        mixins: [validationMixin],

        validations: {
            // validations
            form: {
                email: {required},
                password: {required},
            },
        },

        data: () => ({
            // data
            form: {
                email: null,
                password: null
            },
            title: "Login",
            appName,
            appSubName,
            password_visibility: false,
            logo,
        }),
        computed: {
            // computed
            email_errors() {
                const errors = [];
                if (!this.$v.form.email.$dirty) return errors;
                !this.$v.form.email.required && errors.push('Username harus diisi.');
                return errors;
            },

            password_errors() {
                const errors = [];
                if (!this.$v.form.password.$dirty) return errors;
                !this.$v.form.password.required && errors.push('Password harus diisi.');
                return errors;
            },
        },

        methods: {
            async login() {
                this.$v.form.$touch();
                if (!this.$v.form.$invalid) {
                    const username = this.form.email;
                    const password = this.form.password
                    // Fetch the user.
                    await this.$store.dispatch('auth/login', {username, password});

                    // Redirect home.
                    this.$router.push({name: 'ticketing'});
                }
            }
        },
    }
</script>
